import React from 'react';

const Skills = () => {
  const skills = [
    { name: 'HTML', image: 'https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg' },
    { name: 'CSS', image: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg' },
    { name: 'JavaScript', image: 'https://upload.wikimedia.org/wikipedia/commons/9/99/Unofficial_JavaScript_logo_2.svg' },
    { name: 'ReactJS', image: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg' },
    { name: 'Node.js', image: 'https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_f0b606abb6d19089febc9faeeba5bc05/nodejs-development-services.png' },
    { name: 'MongoDB', image: 'https://miro.medium.com/v2/resize:fit:512/1*doAg1_fMQKWFoub-6gwUiQ.png' },
    { name: 'Express.js', image: 'https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png' },
    { name: 'Git', image: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg' },
    { name: 'Competitive Programming', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQU-70RJhHl2_GbTvRfA7wqid4Vfqp2_-rLuYFQ-ykw4HYmf7DITURVgZZID8aQfJkVHiA&usqp=CAU' },
    { name: 'Python', image: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg' },
    { name: 'Tailwind CSS', image: 'https://adware-technologies.s3.amazonaws.com/uploads/technology/thumbnail/31/tailwind.png' },
    { name: 'C++', image: 'https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg' }
  ];

  const projects = [
    { name: 'Khana Khajana', image: 'https://assets1.hospitalitytech.com/s3fs-public/styles/primary_articles_short/public/2024-01/noodles_app_recommendation_engine.jpg?VersionId=JD9wRs0ZP6Z1Xu554.OMcVLjf2sF_oR2&h=09edcfa9&itok=e2tIQ04C', link: 'https://khana-khajana3.netlify.app/' },
    { name: 'Silver Screen Symphony', image: 'https://mir-s3-cdn-cf.behance.net/projects/404/da82aa113933149.6031a799ce041.png', link: 'https://ramo74dixit.github.io/SilverScreen-Symphony/' }
  ];

  return (
    <div className="bg-gradient-to-r from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90%">
      <div className="container mx-auto py-8">
        <h1 className="text-center text-3xl font-extrabold mb-8">My Top Skills</h1>
        <div className="flex flex-wrap justify-center">
          {skills.map((skill, index) => (
            <div key={index} className="m-4 p-4 bg-stone-700 text-white rounded-lg shadow-lg text-center w-1/3 sm:w-auto">
              <img src={skill.image} alt={skill.name} className="w-12 h-12 mx-auto mb-2" />
              <p className="font-bold">{skill.name}</p>
            </div>
          ))}
        </div>
        <hr className="container mx-auto py-8" />
        <h1 className="text-center text-3xl font-extrabold mb-8">My Top Projects</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 justify-center">
          {projects.map((project, index) => (
            <div key={index} className="mx-8 mb-8 sm:mx-1 sm:mb-1 w-full sm:w-80">
              <div className="rounded-lg shadow-lg overflow-hidden bg-white flex justify-center">
                <div className="flex flex-col justify-center">
                  <img src={project.image} alt={project.name} className="w-full h-64 object-cover object-center" />
                  <div className="p-4">
                    <h2 className="text-lg font-semibold mb-2 text-center text-gray-800">{project.name}</h2>
                    <div className="flex justify-center">
                      <a href={project.link} target="_blank" rel="noopener noreferrer" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                        View Live Project
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
